import { Row as RowAntd } from 'antd';
import type { ComponentProps } from 'react';
import { useGetGutter } from './hooks';

export type RowProperties = ComponentProps<typeof RowAntd>;

const Row = ({ gutter, ...props }: RowProperties) => {
  const resolvedGutter = useGetGutter({ gutter });

  return <RowAntd {...props} gutter={resolvedGutter} />;
};

export default Row;
